<template>
  <div id="fulfillment-list">
    <div>
      <div class="row">
        <div class="col-12">
          <b-form>
            <b-tabs class="custom-tab">
              <b-tab :title="'Privilege'" :title-link-class="['font-medium-5']">
                <fulfillment-privilege-list />
              </b-tab>
              <b-tab
                :title="'Product'"
                :title-link-class="['font-medium-5']"
                disabled
              >
              </b-tab>
              <b-tab
                :title="'Inventory'"
                :title-link-class="['font-medium-5']"
                disabled
              >
              </b-tab>
              <b-tab
                :title="'Order'"
                :title-link-class="['font-medium-5']"
                disabled
              >
              </b-tab>
            </b-tabs>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FulfillmentPrivilegeList from "./component/FulfillmentPrivilegeList.vue";

export default {
  components: { FulfillmentPrivilegeList },
};
</script>

<style>
@import "~@/assets/css/pages/fulfillment/fulfillment-list.css";
@import "~@/assets/css/override-styles/progress-nav.css";
</style>
